export const configFaturamento = [
    {
      category: "configuracoes",
      key: "listaPrecos",
      name: "Listas de preços",
    },
  ];
  